import React from "react";
import "./Testimonials_card.css";
import { Row, Col } from "react-bootstrap";

function Testimonials_card() {
  return (
    <>
      <section className="testimonials_card">
        <div className="testimonials_card_inner">
          <div className="left_text_holder">
            <div className="left_box">
              <h5 className="user_name">
                Shekhar <br /> Rao
              </h5>

              <div className="rating_box">
                <h2>4.5</h2>
                <span>★</span>
              </div>
            </div>
            <div>
              <div className="profile_img_box">
                <img src="https://i.pravatar.cc/200?img=12" alt="user" />
              </div>
            </div>

            <div className="right_box">
              <p>
                I am happy with the product easy to handle, carry and size is
                perfectly comfortable. Once you will buy this I am sure you
                water intake also enhance especially from this vessel.
              </p>
            </div>
          </div>
        </div>
        <div className="line_divider"></div>
      </section>
    </>
  );
}

export default Testimonials_card;
